import { useState } from 'react';

import { useDeleteTechnologicalMapMutation } from '@app/api/TechnologicalMaps';
import type { UseFinalTechMapTableProps } from '@app/components/RecordModal/components/TechnologicalMap/components/FinalTechMapTable/types';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

export const useFinalTechMapTable = ({
  recordTechnologicalMapData,
  refetchRecordTechnologicalMap,
}: UseFinalTechMapTableProps) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const { showNotification } = useNotification();
  const { activeBranchId: ActiveBranchId } = useUserPrint();

  const [
    deleteTechnologicalMap,
    { isLoading: isDeleteTechnologicalMapLoading },
  ] = useDeleteTechnologicalMapMutation();

  const handleTechnologicalMapCancel = async () => {
    try {
      await deleteTechnologicalMap({
        ActiveBranchId,
        mapId: recordTechnologicalMapData?.Id!,
      }).unwrap();
      await refetchRecordTechnologicalMap();

      showNotification('Технологическая карта успешно отменена', 'success');
      setIsDeleteModalOpen(false);
    } catch (error) {
      showNotification(handleCatchError(error));
    }
  };

  return {
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleTechnologicalMapCancel,
    isDeleteTechnologicalMapLoading,
  };
};
